import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_MODIFIER_CATEGORY } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { AddModifierCategoryInput } from "src/interfaces/modifier.interface";
import { add_modifier_category } from "src/store/features/modifier-categories-slice";

export const useAddModifierCategory = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  
  const [isAddingModifierCategory, setIsAddingModifierCategory] = useState(false);

  const addModifierCategoryMutation = useCallback(
    async (addModifierCategoryInput: AddModifierCategoryInput) => {
      setIsAddingModifierCategory(true);

      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: ADD_MODIFIER_CATEGORY,
          variables: {
            addModifierCategoryInput,
          },
        });

        if (data?.data?.addModifierCategory) {
          dispatch(add_modifier_category(data.data.addModifierCategory));
          successToast("Modifier category has been added successfully!");
        }
      } catch (err) {
        console.error("Error adding modifier category:", err);
        const errorMessage = "Failed to add modifier category";
        failureToast(errorMessage);
      } finally {
        setIsAddingModifierCategory(false);
      }
    },
    [axBe, dispatch]
  );

  return {
    isAddingModifierCategory,
    addModifierCategory: addModifierCategoryMutation,
  };
};
